StepHandler = App.loadClass 'grower::handlers/placement/StepHandler'

class exports.TextboxesHandler extends StepHandler

    inputSel: 'input[type="text"]'


    addValidationRules: () ->
        @validator.registerRule
            selector: '.validate-int'
            text: '%s must be a whole number'
            func: (elem) =>
                val = $(elem).val()
                return not val or (not isNaN(val) and String(parseInt(val)) is val)

        @validator.registerRule
            selector: '.validate-in-range'
            text: '%s must be within an appropriate range'
            func: (elem) =>
                # see if we even have a number here first
                val = $(elem).val()
                val = if (val and not isNaN val) then parseFloat val else null
                if not val? then return true

                # grab the min from data-min
                min = $(elem).attr('data-min')
                min = if (min and not isNaN min) then parseFloat min else null
                minValid = min? and val >= min

                # grab the max from data-max
                max = $(elem).attr('data-max')
                max = if (max and not isNaN max) then parseFloat max else null
                maxValid = max? and val <= max

                # set the text depending on the min and max specified
                if min? and max? and not (minValid and maxValid)
                    @validator.rules['.validate-in-range'].text = "%s must be between #{min} and #{max}"
                    return false
                else if min? and not minValid
                    @validator.rules['.validate-in-range'].text = "%s must be greater than or equal to #{min}"
                    return false
                else if max? and not maxValid
                    @validator.rules['.validate-in-range'].text = "%s must be less than or equal to #{max}"
                    return false
                else
                    @validator.rules['.validate-in-range'].text = '%s must be within an appropriate range'
                    return true


    getFieldAspect: (fieldID, aspectID) ->
        yArray = @taffyObjects.axes(name: 'Y').select('array')[0]

        if yArray is 'fields'
            retval =
                value: parseInt(@getInputEl(field: fieldID, aspect: aspectID).val()) or null

        else if yArray is 'y_aspects'
            retval =
                value: parseInt(@getInputEl(aspect: aspectID).val()) or null

        return retval


    setFieldAspect: (fieldAspect) ->
        yArray = @taffyObjects.axes(name: 'Y').first().array

        if yArray is 'fields'
            input = @getInputEl
                field: fieldAspect.fields_id,
                aspect: fieldAspect.aspects_id

        else if yArray is 'y_aspects'
            input = @getInputEl
                aspect: fieldAspect.aspects_id

        input.val(fieldAspect.value ? '')
